import { TextKey, ActionType, FeatureFlag } from '@mews-commander/enums';
import { LocalizedText, useFeatureFlag } from '@mews/framework';
import { IconName } from '@optimus-web/icons';
import { HeadingAction } from '../../../legacy/React/Components/HeadingAction/Action/types';
import { BaseLayout } from '../../../components/layout';
import { YOULEND_WEBSITE } from '../constants';
import { PrequalifiedUsers } from './PrequalifiedUsers';
import { NonEligibleUsers, NonPrequalifiedUsers } from './NonPrequalifiedUsers';

export const FinancialServicesCapitalPage = () => {
    const isPrequalifiedUser = useFeatureFlag(FeatureFlag.financialServicesCapitalPrequalifiedUsersEnabled);
    const isAutorizedAccess = useFeatureFlag(FeatureFlag.financialServicesCapitalAccess);

    const youlendMoreInfo: Array<HeadingAction> = [
        {
            icon: IconName.Help,
            actionId: 'youlendInfo',
            text: <LocalizedText textKey={TextKey.FinancialServicesCapitalAboutYoulend} />,
            type: ActionType.Link,
            target: '_blank',
            url: YOULEND_WEBSITE,
        },
    ];

    const renderContent = () => {
        if (isAutorizedAccess && isPrequalifiedUser) {
            return <PrequalifiedUsers />;
        }
        if (isAutorizedAccess && !isPrequalifiedUser) {
            return <NonPrequalifiedUsers />;
        }

        return <NonEligibleUsers />;
    };

    return (
        <BaseLayout title={<LocalizedText textKey={TextKey.FinancialServicesMewsCapital} />} actions={youlendMoreInfo}>
            {renderContent()}
        </BaseLayout>
    );
};
